import { NgModule } from '@angular/core';
import { MainLogoComponent } from '@app/infrastructure/components/main-logo/main-logo.component';
import { CommonModule, NgOptimizedImageModule } from '@angular/common';

@NgModule({
	declarations: [MainLogoComponent],
	exports: [MainLogoComponent],
	imports: [
		CommonModule,
		NgOptimizedImageModule,
	],
})
export class MainLogoModule {}
